const getBaseColumnsFromGridConfig = (name, gridConfig) => {
    return gridConfig.base[name]
}
const getAttributeColumnsFromGridConfig = (name, gridConfig) => {
    return gridConfig.attribute[name]
}

export { getAttributeColumnsFromGridConfig, getBaseColumnsFromGridConfig }